import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
/**
 * XP progress bar from the start of the current level to the next one.
 */
export default class LevelProgress extends Component {
  view() {
    const user = this.attrs.user;
    const xp = user.attribute('levelXp') || 0;
    const current = user.attribute('levelXpCurrent') || 0;
    const next = user.attribute('levelXpNext');
    const maxed = next === null || next === undefined;
    const percent = maxed ? 100 : next > current ? Math.min(100, Math.max(0, (xp - current) / (next - current) * 100)) : 0;
    return m("div", {
      className: "SLevelProgress",
      role: "progressbar",
      "aria-valuemin": current,
      "aria-valuemax": maxed ? xp : next,
      "aria-valuenow": xp
    }, m("div", {
      className: "SLevelProgress-bar"
    }, m("div", {
      className: "SLevelProgress-fill",
      style: {
        width: `${percent}%`
      }
    })), m("div", {
      className: "SLevelProgress-text"
    }, maxed ? app.translator.trans('hawer-s-level.forum.max_level_text', {
      xp
    }) : app.translator.trans('hawer-s-level.forum.progress_text', {
      current: xp,
      next
    })));
  }
}
flarum.reg.add('hawer-s-level', 'forum/components/LevelProgress', LevelProgress);